import React from 'react';
import { Modal, InputNumber, Row, Col, Icon, Form, Button, Alert } from 'antd';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { JS } from 'aws-amplify';
import GoogleAuth from '@services/graphQL/graphQLGoogleAuth'
import GoogleVision from '@services/GoogleVision';
import _ from 'lodash';

interface Props {
  isVisible: boolean,
  image: string;
  qtd: number[];
  qtdAPI: number[]
  configurationItems: any[];
  onToggleModal: Function;
  modelId: string;
  projectId: string;
  onSave: Function;
};

export default class ImageRecognitionModalExecutionComponent extends React.Component<Props, any> {
  private _googleAlth: GoogleAuth;

  constructor(props: Props) {
    super(props);
    this._googleAlth = new GoogleAuth();

    this.state = {
      itemsValues: [],
      resultValues: [],
      qtdValues: props.qtd || [],
      qtdValuesAPI: props.qtdAPI || [],
      loading: false,
      errorAPI: undefined
    };
    this.saveRecognitionItems = this.saveRecognitionItems.bind(this)


  }
  componentWillMount() {
    const { qtdValues, loading } = this.state;
    if (this.state.qtdValues.length > 0) {
      let newItemsValues: any = []
      qtdValues.map((qtd: any, index: number) => {
        let items = this.handleItemData(qtd, index);
        newItemsValues.push(items)
      })
      this.setState({ itemsValues: newItemsValues })
    } else {
      this.setInitials()
      if (!loading && !['', null, undefined,'.pdf','.PDF'].includes(this.props.image)) {
        this.setState({ loading: true }, () => this.requestImgRec())
      }
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    const { qtdValues, itemsValues, loading } = this.state;
    const { image } = this.props;
    let newItemsValues = [...itemsValues];
    if (!_.isEqual(prevState.qtdValues, qtdValues)) {
      qtdValues.map((qtd: any, index: number) => {
        if (prevState.qtdValues[index] !== qtdValues[index]) {
          newItemsValues[index] = this.handleItemData(qtd, index)
        }
      })
      this.setState({ itemsValues: newItemsValues })
    }
    if (!loading && !['', null, undefined,'.pdf','.PDF'].includes(image) && !_.isEqual(prevProps.image, image)) {
      this.setState({ loading: true }, () => this.requestImgRec())
    }

  }
  setInitials() {
    const { configurationItems } = this.props
    const initials = configurationItems.map(c => ({
      iconType: 'close-circle',
      iconColor: 'red',
      itemMessage: 'errorMessage'
    }))
    this.setState(({ itemsValues: initials }))
  }
  async requestImgRec() {

    let imgBase64: string
    const toDataURL = url => fetch(url)
      .then(response => response.blob())
      .then(blob => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      }))
    await toDataURL(this.props.image)
      .then(dataUrl => {
        imgBase64 = dataUrl.split(',')[1];
      })
    let token = await this._googleAlth.doAuth()
    let results = await GoogleVision.requestImageRecognition(this.props.projectId, this.props.modelId, imgBase64, token.getGoogleToken.access_token)
    if (results.payload) {
      this.setResults(results.payload)
    } else {
      if(!results.data){
        this.setResults([])
      }else
      this.setState({ errorAPI: 400 }) //Fixo até levantar todos os possiveis respostas de erros!
    }
    this.setState({ loading: false })
  }
  setResults(results: Array<any>) {
    const { qtdValues } = this.state;
    const { configurationItems } = this.props;
    let newQtdValues = [...qtdValues]
    configurationItems.map((item: any, index: number) => {
      newQtdValues[index] = results.filter((result: any) => result.displayName === item.code).length
    })
    this.setState({ qtdValues: newQtdValues, qtdValuesAPI: newQtdValues })
  }
  handleItemData(itemValue: number, index: number) {
    const { quantityMax, quantityMin } = this.props.configurationItems[index];
    const value = itemValue
    if (!value) {
      return {
        iconType: 'close-circle',
        iconColor: 'red',
        itemMessage: 'errorMessage'
      }
    }
    if (value < quantityMin || value > quantityMax) {
      return {
        iconType: 'exclamation-circle',
        iconColor: 'orange',
        itemMessage: 'partialMessage'
      }
    }
    if (value >= quantityMin && value <= quantityMax) {
      return {
        iconType: 'check-circle',
        iconColor: 'green',
        itemMessage: 'successMessage'
      }
    }
    return {}
  }
  onChangeQuantidy(evt: any, index: number) {
    let newqtdValues = [...this.state.qtdValues]
    newqtdValues[index] = evt;
    this.setState({ qtdValues: newqtdValues })
  }
  saveRecognitionItems() {
    this.props.onSave(this.state.qtdValuesAPI, this.state.qtdValues)
  }
  render() {
    const { isVisible, configurationItems, onToggleModal } = this.props
    const { itemsValues, qtdValues, loading, errorAPI } = this.state
    return (
      <Modal
        visible={isVisible}
        footer={false}
        closable={false}
        destroyOnClose={true}
        className="image-recognition-modal"
        style={{ top: '2vh' }}
        width={'50%'}
      >
        <ModalStyle>
          <Row className="imgContainer">
            {loading &&
              <LoadingImg>
                <Icon type="loading" />
              </LoadingImg>}
              <img src={this.props.image} alt="image" style={{ opacity: loading || errorAPI ? 0.3 : 1 }} />
          </Row>
          <Row type='flex' justify='center'>
            <Col span={10}>{errorAPI ? <Alert showIcon message={I18n.l(`imageRecognition.modalExecution.errorAPI${errorAPI}`)} type="warning" /> : ''}</Col>
          </Row>
          <Row className="header" gutter={16} type="flex" align="bottom">
            <Col span={7}><b>{I18n.l('imageRecognition.modalExecution.itemsFound')}</b></Col>
            <Col className='qtdText' span={5}><b>{I18n.l('imageRecognition.modalExecution.quantity')}</b></Col>
            {configurationItems.length > 1 &&
              <>
                <Col span={7}><b>{I18n.l('imageRecognition.modalExecution.itemsFound')}</b></Col>
                <Col className='qtdText' span={5}><b>{I18n.l('imageRecognition.modalExecution.quantity')}</b></Col>
              </>
            }
          </Row>

          <Row gutter={16}>
            <Form>
              {!errorAPI && configurationItems.map((item: any, index: any) => (
                <div key={index}>
                  <Col span={12}>
                    <Row className='headerConfItem' >
                      <Col span={18}>
                        <span>{item.name}</span>
                      </Col>
                      {!loading ? <>
                        <Col span={4}>
                          <InputNumber size='small' onChange={(e) => this.onChangeQuantidy(e, index)} min={0} value={qtdValues[index]} defaultValue={0} />
                        </Col>
                        <Col span={2} style={{ textAlign: 'center' }}>
                          <Icon type={itemsValues[index].iconType} theme="filled" style={{ color: itemsValues[index].iconColor }} />
                        </Col>
                      </>
                        :
                        <Col span={6} style={{ textAlign: 'center' }}>
                          <Icon type="loading" />
                        </Col>
                      }
                    </Row>
                    <Row>
                      {!loading && <CardItem>
                        <div dangerouslySetInnerHTML={{ __html: item[itemsValues[index].itemMessage] }} />
                      </CardItem>}
                    </Row>
                  </Col>
                </div>
              ))}
            </Form>
          </Row>
          <Row className="footer">
            <Col className='footer-btns'>
              <Button onClick={onToggleModal} type="link">
                {I18n.l('common.cancel')}
              </Button>

              <Button type="primary" className="ml-1" onClick={this.saveRecognitionItems}>
                {I18n.l('common.create')}
              </Button>
            </Col>
          </Row>
        </ModalStyle>
      </Modal>
    );
  }
}

const ModalStyle = styled.div`
  height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
  .ant-row {
    padding: 5px 0px 5px 0px;
  }
  .header{
    text-transform: uppercase;
    font-size: 12px;
  }
	.imgContainer{
    display: flex;
    justify-content: center;
		img{
			height: 250px;
		}
	}
	.qtdText{
		text-align: right;
  }
  .headerConfItem{
    .ant-input-number{
      width: 100%
    }
  }
  .footer {
    background-color: white;
    display: flex;
    justify-content: flex-end;
    height: 50px;
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: calc(100% - 0px);
    .footer-btns {
      position: absolute;
      text-align: right;
      right: 30px;
    }
  }
  `;
const CardItem = styled.div`
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  font-size: 12px
  min-width: 40px;
  padding: 10px;
`;

const LoadingImg = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 100px;
`;

